import clsx from 'clsx';
import Link from 'next/link';

import Button from '@/components/elements/Button';
import Typography from '@/components/elements/Typography';

import { ArrowLeft, ArrowRight } from '../icons';

export type HelpItem = {
  title: string;
  link: string;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type HelpBarProps = {};

const helpItems: HelpItem[] = [
  {
    link: `/faq/bionical`,
    title: `What is Botanical?`,
  },
  {
    link: `/faq/wallet`,
    title: `Transfer crypto from spot wallet to p2p wallet on binance`,
  },
  {
    link: `/faq/setup`,
    title: `How to setup and use Botanical?`,
  },
];

/**
 * @component Sidebar
 */
// eslint-disable-next-line no-empty-pattern
function HelpBar({}: HelpBarProps) {
  const classes = clsx(
    `transition-all fixed right-0 top-0 z-50 pt-36 hidden xl:block px-4 py-9 w-[380px] overflow-hidden whitespace-nowrap h-screen bg-gray-50`,
  );

  const renderHelpItem = ({ link, title }: HelpItem) => (
    <Link href={link} key={link}>
      <a className="flex select-none flex-row p-4 rounded-lg justify-between items-center bg-white ">
        <Typography
          variant="no-style"
          className="whitespace-normal text-[14px] italic"
        >
          {title}
        </Typography>
        <ArrowRight className="flex-shrink-0" />
      </a>
    </Link>
  );

  return (
    <div className={classes}>
      <Typography as="h3" variant="h5" className="mx-3 mb-4">
        Need a hand?
      </Typography>
      <div className="flex flex-col space-y-4 mb-12">
        {helpItems.map(renderHelpItem)}
      </div>
      <div className="mx-3">
        <Typography as="h3" variant="h5" className="mb-4">
          No exchange account yet?
        </Typography>
        <Button size="small" variant="outlined" color="primary">
          Sign up at Binance
        </Button>
      </div>
    </div>
  );
}

export default HelpBar;
